/**
 * @generated SignedSource<<6ac04e6ebbaa164ba2fa0307532ed8f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AssignmentStudentsWithSkillStatesQuery$variables = {
  classIds: ReadonlyArray<string>;
  skillId: string;
};
export type AssignmentStudentsWithSkillStatesQuery$data = {
  readonly studentSkillAndEssentialPredecessorsProgress: ReadonlyArray<{
    readonly skillStatuses: ReadonlyArray<{
      readonly isPassedOrInferred: boolean;
      readonly readinessScore: any | null | undefined;
      readonly skill: {
        readonly code: string | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
      };
    }>;
    readonly student: {
      readonly classes: ReadonlyArray<{
        readonly id: string;
      } | null | undefined> | null | undefined;
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly publicUserId: string | null | undefined;
    };
  }>;
};
export type AssignmentStudentsWithSkillStatesQuery = {
  response: AssignmentStudentsWithSkillStatesQuery$data;
  variables: AssignmentStudentsWithSkillStatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "classIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skillId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "classIds",
        "variableName": "classIds"
      },
      {
        "kind": "Variable",
        "name": "targetSkillId",
        "variableName": "skillId"
      }
    ],
    "concreteType": "StudentSkillAndPredecessorsProgress",
    "kind": "LinkedField",
    "name": "studentSkillAndEssentialPredecessorsProgress",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "student",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClassNode",
            "kind": "LinkedField",
            "name": "classes",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillStatus",
        "kind": "LinkedField",
        "name": "skillStatuses",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillNode",
            "kind": "LinkedField",
            "name": "skill",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPassedOrInferred",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "readinessScore",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignmentStudentsWithSkillStatesQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignmentStudentsWithSkillStatesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "174435efe7c5b0ed8a5156f50fe78b8e",
    "id": null,
    "metadata": {},
    "name": "AssignmentStudentsWithSkillStatesQuery",
    "operationKind": "query",
    "text": "query AssignmentStudentsWithSkillStatesQuery(\n  $classIds: [ID!]!\n  $skillId: ID!\n) {\n  studentSkillAndEssentialPredecessorsProgress(classIds: $classIds, targetSkillId: $skillId) {\n    student {\n      id\n      firstName\n      lastName\n      publicUserId\n      classes {\n        id\n      }\n    }\n    skillStatuses {\n      skill {\n        id\n        name\n        code\n      }\n      isPassedOrInferred\n      readinessScore\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cfd954645c0925edb7329b16a5c7e2d9";

export default node;
